// extracted by extract-css-chunks-webpack-plugin
module.exports = {"playerBox":"playerBox-29Xiv51r","playerContainer":"playerContainer-15221yLe","min_playerContainer":"min_playerContainer-20GoY5I3"};